'use client';

import { OrderTriggerCondition } from '@drift-labs/sdk';
import { matchEnum } from '@drift/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';
import { getTriggerPriceFromOrder } from 'src/utils/order';

interface TriggerConditionCellProps {
	order: ParentOrderInfo;
}

export function TriggerConditionCell({ order }: TriggerConditionCellProps) {
	const { triggerPrice, triggerCondition } = order;

	if (triggerPrice.eqZero()) {
		return <span className="text-text-tertiary">-</span>;
	}

	const isAbove =
		matchEnum(triggerCondition, OrderTriggerCondition.ABOVE) ||
		matchEnum(triggerCondition, OrderTriggerCondition.TRIGGERED_ABOVE);

	return (
		<>
			{isAbove ? '> ' : '< '}
			{getTriggerPriceFromOrder(order)}
		</>
	);
}
